import { createActions } from 'redux-actions';

export const actions = createActions({
  QLIK: {
    CREATE_SESSION: () => {},
    DESTROY_SESSION: () => {},
    SET_SESSION_ID: (payload) => payload,
  },
}).qlik;
